import { useAttachmentContent } from '../../hooks/useAttachmentsContent';
import { ProgramAttachment } from '../../types';
import { BoxSpinner } from '../../../commons/components/Spinner';
import React from 'react';

export const ImgPreview = (props: { programId: string; attachment: ProgramAttachment }) => {
  const { programId, attachment } = props;
  const { data: attachmentWithContent, status } = useAttachmentContent(programId, attachment);

  if (status === 'loading') {
    return (
      <div className="carousel__media-container carousel__image-container--loading">
        <BoxSpinner />
      </div>
    );
  }

  if (status === 'error' || !attachmentWithContent?.url) {
    return (
      <div className="carousel__media-container carousel__image-container--error">
        <div className="carousel__image-error">Failed to load image</div>
      </div>
    );
  }
  return (
    <img
      src={attachmentWithContent.url}
      alt={attachment.name}
      className="carousel__media"
      crossOrigin="anonymous"
    />
  );
};
